import { Player } from "./Player";
import { reviver, replacer, NatPlayer, NatGameStateBase } from "./utils";
import {
  NatscopeClient,
  ChiefRoom,
  T_onUserLeave,
  T_onUserDisconnect,
  T_onMyRoomReady,
  T_onUserJoin,
  T_onUserPos,
  T_onData,
  Moving,
  Room,
} from "./../../../natscope_modules/natscope-core";

import { FikscopeEngine } from "./FikscopeEngine";
import { GameStateBase } from "./GameStateBase";

/* import { Pawn } from "../engine/Pawn"; */
/* import { FikscopeObject3D } from "./Object"; */
import { FikscopeLevel } from "./FikscopeLevel";

import { log } from '../logMode';

export type INCommand = "Player" | "FikscopeLevel" | "GameState";
// export type INDataType = Player | FikscopeLevel | GameStateBase;
export type INDataType = string;

export class INatCmd {
  cmd: INCommand;
  data: INDataType;

  constructor(cmd: INCommand, data: INDataType) {
    this.cmd = cmd;
    this.data = data;
  }
}

export type FENatscope_cons_type = {
  fe: FikscopeEngine;
  natscope: NatscopeClient;
  netUpdateFrequency?: number;
  bStop?: boolean;
};

export class FENatscope {
  private _natscope: NatscopeClient;

  private _NetUpdateFrequency: number; // every in ms

  private _status: boolean; // true → running

  private _nIntervalId: NodeJS.Timeout | undefined;

  private _currentState: GameStateBase;

  public fe: FikscopeEngine;

  set currentState(b: GameStateBase) {
    this._currentState = b;
  }

  get currentState(): GameStateBase {
    return this._currentState;
  }

  get natscope(): NatscopeClient {
    return this._natscope;
  }

  set NetUpdateFrequency(n: number) {
    this._NetUpdateFrequency = n;
  }

  get NetUpdateFrequency(): number {
    return this._NetUpdateFrequency;
  }

  set status(b: boolean) {
    this._status = b;
  }

  get status(): boolean {
    return this._status;
  }

  constructor({ fe, natscope, netUpdateFrequency = 20 }: FENatscope_cons_type) {
    this.fe = fe;
    this._natscope = natscope;
    this._NetUpdateFrequency = netUpdateFrequency;
    this._status = false;
    this._currentState = fe.gameState;

    natscope.onUserDisconnect.on(this.onUserDisconnect.bind(this));
    natscope.onMyRoomReady.on(this.onMyRoomReady.bind(this));

    // natscope.onUserJoin = (user) => this.onUserJoin(user);
    if (this.natscope.myroom) {
      this.initRoom(this.natscope.myroom);
    }
  }

  public start() {
    if (!this.status) {
      let _this = this;
      this._nIntervalId = setInterval(
        () => _this.update(),
        this.NetUpdateFrequency
      );
      this.status = false;
    } else {
      console.warn(
        "FENatscope - Attempt to START loop communication already running !"
      );
    }
  }

  public stop() {
    if (!this.status) {
      console.warn(
        "FENatscope - Attempt to STOP loop communication already stoped !"
      );
    } else {
      if (this._nIntervalId) {
        clearInterval(this._nIntervalId);
      }
      this.status = true;
    }
  }

  public refresh() {
    if (this._nIntervalId) {
      clearInterval(this._nIntervalId);
    } else {
      console.warn("No intervalId");
    }
    if (!this.status) {
      let _this = this;
      this._nIntervalId = setInterval(
        () => _this.update(),
        this.NetUpdateFrequency
      );
    }
  }

  public sendPlayerPosition(p: Player) {
    this.natscope.send_pos(p.pawn!.position, p.pawn!.quaternion);
  }

  public update() {
    // May send udpates only if state has changed ?
    if (this.natscope.me) {
      //If it's chief instance
      if (this.natscope.myroom && this.natscope.myroom instanceof ChiefRoom) {
        //Broadcast the entire Gamestate to everyone in the room
        this.natscope.myroom.safeBroadcastData(
          new INatCmd("GameState", JSON.stringify(this.fe.gameState, replacer))
        );
      } else {
        //If you're only peer, send your position
        let me = this.fe.gameState.players.get(this.natscope.me.id);
        if (me) {
          this.sendPlayerPosition(me);
        } else {
          console.warn("could not get me");
          return;
        }
      }
    } else {
      console.warn("natscope.me undefined");
      return;
    }
  }

  public onMyRoomReady(detail:T_onMyRoomReady) {
    // console.warn('FENatscope - onMyRoomReady');
    const { room } = detail;
    this.initRoom(room);
  }

  public initRoom(myroom: Room) {
    // console.warn('FENatscope - initRoom');
    myroom.onUserLeave.on(this.onUserLeaveRoom.bind(this))
    myroom.onUserJoin.on(this.onUserJoinRoom.bind(this))
    myroom.onUserPos.on(this.onUserPos.bind(this))
    myroom.onData.on(this.onData.bind(this))
  }

  public onUserJoinRoom(detail: T_onUserJoin): void {
    // console.warn('FENatscope - onUserJoinRoom');
    const { user, room } = detail;
    // if not me joining room
    if (this.natscope.me && this.natscope.me.id !== user.id) {
      log(user.nick + " joining the room " + room.name);
      let peerPlayer = this.fe.gameState.map.newPlayerPeer(
        this.fe,
        user.nick,
        user.id
      );
      if (this.natscope.myroom) {
        if (this.natscope.myroom instanceof ChiefRoom) {
          // Test sending Player object
          // FIXME impossible to send circular object by json
          /* console.error("Players in gameState sent :") */
          /* console.error(this.fe.gameState.players) */
          this.natscope.myroom.send_to(
            user.id,
            new INatCmd(
              "GameState",
              JSON.stringify(this.fe.gameState, replacer)
            ),
            "data"
          );

          this.natscope.myroom.send_to(
            user.id,
            new INatCmd("Player", JSON.stringify(peerPlayer, replacer)),
            "data"
          );
        }
      }
      // if me joining room
    } else {
      if (this.natscope.myroom) {
        this.natscope.myroom.users.forEach((myUser) => {
          if (this.natscope.me && this.natscope.me.id !== myUser.id) {
            this.fe.gameState.map.newPlayerPeer(
              this.fe,
              myUser.nick,
              myUser.id
            );
          }
        });
      }
    }
  }

  public onUserPos(detail: T_onUserPos): void {
    // console.warn('FENatscope - onUserPos');
    const player: Moving = detail;
    const p = this.fe.gameState.players.get(player.id);
    if (p) {
      p.move(player.pos);
    } else {
      console.warn("p undefined");
    }
  }

  public onUserDisconnect(detail: T_onUserDisconnect): void {
    // console.warn('FENatscope - onUserDisconnect');
    const { user } = detail;
    log(user.nick + " has left !");
    this.fe.gameState.map.removePlayer(this.fe, user.id);
  }

  public onUserLeaveRoom(detail: T_onUserLeave): void {
    // console.warn('FENatscope - onUserLeaveRoom');
    const { user, room } = detail;
    log(user.nick + " has left the room " + room.name);
    this.fe.gameState.map.removePlayer(this.fe, user.id);
  }

  public updateGameState(gs: NatGameStateBase) {
    gs.players.forEach((p: NatPlayer) => {
      log(p);
      let our_p = this.fe.players.has(p.id)
        ? this.fe.players.get(p.id)
        : this.fe.map.newPlayerPeer(this.fe, p.nick, p.id);
      log(p);
      //Do not move yourself (it may be the case in future when controls will be
      //shared to server)
      if (our_p!.id !== this.natscope.me.id) {
        our_p!.move(p.position);
      }
    });
  }

  public onData(detail: T_onData): void {
    console.warn("FENatscope - onData");
    const data = detail;
    try {
      let msg = data as INatCmd;
      switch (msg.cmd) {
        case "Player":
          let player = JSON.parse(msg.data, reviver) as NatPlayer;
          // let player = msg.data as Player;
          log("Player:");
          log(player);
          break;
        case "FikscopeLevel":
          // let level = msg.data as FikscopeLevel;
          let level = JSON.parse(msg.data, reviver) as FikscopeLevel;
          /* let level = msg.data; */
          log("Level:");
          log(level);
          break;
        case "GameState":
          log("Before GameState:");
          // log(msg.data);
          // let gs = (JSON.parse(msg.data)) as GameStateBase;
          let gs = JSON.parse(msg.data, reviver) as NatGameStateBase;
          // let gs = msg.data as GameStateBase;
          log("After GameState:");
          // console.warn(gs);
          this.updateGameState(gs);
          break;
      }
    } catch (err) {
      console.error("NatFikscope ", err);
    }
  }
}
